var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._g({
    class: {
      marL: _vm.leftmenu, Inight: _vm.night
    },
    style: ({
      'background-color': _vm.Ibg
    }),
    attrs: {
      "id": "app"
    }
  }, {
    click: _vm.hideMenu,
    touchstart: _vm.ts,
    touchmove: _vm.tm,
    touchend: _vm.te
  }), [_c('header', {
    attrs: {
      "id": "header"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/menu.png")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.leftMenus($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./assets/portmenu.png")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.rightMenus($event)
      }
    }
  })]), _vm._v(" "), _c('leftMenu', _vm._g({
    class: {
      L: _vm.leftmenu
    }
  }, {
    setting: _vm.Setting,
    showSave: _vm.showSave
  })), _vm._v(" "), _c('rightMenu', _vm._g({
    class: {
      R: _vm.rightmenu
    },
    attrs: {
      "article": _vm.article,
      "save": _vm.isSaved
    }
  }, {
    hidee: _vm.hideRight,
    Save: _vm.Save,
    removeSave: _vm.removeSave,
    article: _vm.NPArticle,
    random: _vm.randomArticle,
    today: _vm.getArticle
  })), _vm._v(" "), _c('router-view', {
    attrs: {
      "article1": _vm.article,
      "night": _vm.night
    }
  }), _vm._v(" "), _c('setting', _vm._g({
    class: {
      hideSetting: _vm.setting
    }
  }, {
    setSize: _vm.setSize,
    setNight: _vm.setNight,
    setBg: _vm.setBg
  })), _vm._v(" "), _c('saveArticle', _vm._g({
    class: {
      showSave: _vm.showS
    },
    attrs: {
      "saveArticles": _vm.saveTotal
    }
  }, {
    hide: _vm.showSave,
    go: _vm.NPArticle
  })), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "sc"
    }
  }, [(_vm.isSC) ? _c('span', {
    staticClass: "SC"
  }, [_vm._v(_vm._s(_vm.issc ? '收藏成功' : '取消收藏'))]) : _vm._e()])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.4@vue-loader/lib/template-compiler?{"id":"data-v-60ac0b50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@13.0.4@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = DXbv
// module chunks = 1